import { render, staticRenderFns } from "./AddEditProject.vue?vue&type=template&id=61253e84&scoped=true&"
import script from "./AddEditProject.vue?vue&type=script&lang=js&"
export * from "./AddEditProject.vue?vue&type=script&lang=js&"
import style0 from "./AddEditProject.vue?vue&type=style&index=0&id=61253e84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61253e84",
  null
  
)

export default component.exports